import { useEffect, useRef, useState } from "react";
import { useInView } from "framer-motion";

const STATS = [
  { value: 50, suffix: "+", label: "Betreute Objekte" },
  { value: 24, suffix: "/7", label: "Erreichbarkeit" },
  { value: 100, suffix: "%", label: "Abnahmegarantie" },
];

function Counter({ value, suffix, run }) {
  const [n, setN] = useState(0);
  useEffect(() => {
    if (!run) return;
    let raf;
    const start = performance.now();
    const dur = 1600;
    const tick = (t) => {
      const p = Math.min((t - start) / dur, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      setN(Math.round(eased * value));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [run, value]);
  return (
    <span className="font-head text-5xl font-light tracking-tighter text-metal sm:text-6xl lg:text-7xl">
      {n}
      <span className="text-[#4fd1c5]">{suffix}</span>
    </span>
  );
}

export default function Stats() {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-100px" });
  return (
    <section ref={ref} className="border-y border-white/10 bg-[#0d0d0f] py-20 lg:py-28">
      <div className="mx-auto grid max-w-[1400px] grid-cols-1 gap-y-14 px-6 sm:grid-cols-3 lg:px-10">
        {STATS.map((s, i) => (
          <div key={s.label} data-testid={`stat-${i}`} className="flex flex-col gap-3 border-l border-white/10 pl-6 lg:pl-8">
            <Counter value={s.value} suffix={s.suffix} run={inView} />
            <span className="font-mono-spc text-[11px] uppercase tracking-[0.25em] text-[#8a919e]">{s.label}</span>
          </div>
        ))}
      </div>
    </section>
  );
}
